"use client";

import type { ReactNode } from "react";
import { useInternalVolumeAccess, InternalVolumeUnavailable } from "@/lib/useInternalVolumeAccess";

/**
 * Renders children only for authenticated internal (owner) users; otherwise the
 * stealth "not found" card. UI-level gate — for full data protection the backing
 * endpoint must also require auth.
 */
export default function InternalGate({ children }: { children: ReactNode }) {
  const { allowed, checked } = useInternalVolumeAccess();
  if (!checked) {
    return (
      <div style={{ textAlign: "center", padding: "2rem", color: "var(--color-text-muted)" }}>
        Checking access…
      </div>
    );
  }
  if (!allowed) return <InternalVolumeUnavailable />;
  return <>{children}</>;
}
